import {Injectable} from '@angular/core';

import {pt} from 'oss-core-kotlin-common-js';

export const {I18nCatalogId} = pt.at.oss.kotlin.core.i18n;
export type I18nCatalogId = pt.at.oss.kotlin.core.i18n.I18nCatalogId;

export interface Catalog {
  [i18nKey: string]: CatalogEntry;
}

export interface CatalogEntry {
  translations: { [localeId: string]: string };
}

declare global {
  interface Window {
    catalogs?: { [idStr: string]: Catalog };
  }
}

/**
 * Service for accessing catalogs provided by the server during startup.
 * FIXME This service is duplicated in oss-pages and oss-registo.
 **/
@Injectable()
export class CatalogService {

  catalogs: Map<I18nCatalogId, Catalog>;

  constructor() {
    this.catalogs = window.catalogs
      ? new Map(
        Object.entries(window.catalogs)
          .map(([idStr, elems]) => [I18nCatalogId[idStr], elems]))
      : new Map();
  }

  getCatalog(catalogId: I18nCatalogId): Catalog {
    return this.catalogs.get(catalogId);
  }

}
